/**
 * `window.__COLPLAT__` is injected by `services/api`'s static-serving step
 * from the `X-Colplat-Base` header (ADR-0015) — nothing in this bundle ever
 * hardcodes a mount path or a WebSocket URL.
 */
export interface ColplatGlobals {
  base: string;
  env: 'prod' | 'test';
  wsPath: string;
  /** Present (and true) only when the server registered the passwordless test-login routes. */
  testLogin?: boolean;
  /** Present (and true) only when bank sync is configured on this server. Decides whether the tab is offered, never what is permitted. */
  bank?: boolean;
}

declare global {
  interface Window { __COLPLAT__: ColplatGlobals }
}

export function globals(): ColplatGlobals {
  return window.__COLPLAT__;
}

/** The href for the app's own root (the launcher), respecting the mount path. */
export function appHref(path = ''): string {
  const base = globals().base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}

export function wsUrl(): string {
  const { wsPath } = globals();
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${wsPath}`;
}
